import type { NotificationListResponseNotificationsItemSourceSourceUserAllOf } from './notificationListResponseNotificationsItemSourceSourceUserAllOf';
import type { NotificationListResponseNotificationsItemSourceSourceUserAllOfTwo } from './notificationListResponseNotificationsItemSourceSourceUserAllOfTwo';

/**
 * 알림을 발생시킨 사용자 정보
 */
export type NotificationListResponseNotificationsItemSourceSourceUser = NotificationListResponseNotificationsItemSourceSourceUserAllOf & NotificationListResponseNotificationsItemSourceSourceUserAllOfTwo;
